export const getVacationTypeById = (id,vacationTypes) =>{
    for (const type of vacationTypes) {
        if(type["@id"]===id)return type
    }
}

